import { createAction } from 'redux-act';
import {
  getShortlist,
  addToShortlist,
  removeFromShortlist,
} from '../../../api/shortlist';
import { toastRender } from '../../../service/toaster';
import { showPopupWindow } from '../Popups';
import { POPUPS } from '../../../service/constants';

export const shortlistLoading = createAction('shortlist loading');
export const setShortlist = createAction('set shortlist');
export const setShortlistError = createAction('set shortlist error');

const normalizeRows = (payload) => {
  const candidate = Array.isArray(payload)
    ? payload
    : payload?.shortlist || payload?.players || payload?.items || [];
  const list = Array.isArray(candidate) ? candidate : [];
  return list
    .map((row) => {
      if (!row || typeof row !== 'object') return null;
      const playerData =
        row.player && typeof row.player === 'object' ? row.player : null;
      const playerId = playerData?._id || row.player || row.playerId || row._id;
      if (!playerId) return null;
      return {
        player: String(playerId),
        playerData,
        note: typeof row.note === 'string' ? row.note : '',
        createdAt: row.createdAt || row.created_at || null,
      };
    })
    .filter(Boolean);
};

export const fetchShortlist = () => async (dispatch) => {
  dispatch(shortlistLoading(true));
  try {
    const response = await getShortlist();
    if (response.status === 200) {
      dispatch(setShortlist(normalizeRows(await response.json())));
    } else {
      dispatch(setShortlist([]));
    }
  } catch {
    dispatch(setShortlist([]));
  } finally {
    dispatch(shortlistLoading(false));
  }
};

export const ensureShortlist = () => async (dispatch, getState) => {
  const shortlist = getState().shortlist || {};
  if (shortlist.initialized || shortlist.loading) return;
  await dispatch(fetchShortlist());
};

export const shortlistAddPlayer =
  (playerId, note) => async (dispatch, getState) => {
    let response;
    try {
      response = await addToShortlist(playerId, note);
    } catch {
      toastRender('error', 'Could not update shortlist.');
      return { ok: false };
    }
    if (response.status === 200) {
      const items = getState().shortlist?.items || [];
      const existing = items.find((item) => item.player === String(playerId));
      const nextNote = note === undefined ? '' : String(note).slice(0, 140);
      const next = existing
        ? items.map((item) =>
            item.player === String(playerId)
              ? { ...item, note: nextNote }
              : item
          )
        : [
            {
              player: String(playerId),
              note: nextNote,
              createdAt: new Date().toISOString(),
            },
            ...items,
          ];
      dispatch(setShortlist(next));
      dispatch(setShortlistError(null));
      return { ok: true };
    }
    if (response.status === 206) {
      dispatch(setShortlistError('limit_free'));
      dispatch(
        showPopupWindow(POPUPS.MOBILE_REQUIRED_POPUP, POPUPS.MOBILE_REQUIRED_POPUP)
      );
      toastRender('error', 'Shortlist full — upgrade for more slots.');
      return { ok: false, status: 206 };
    }
    if (response.status === 205) {
      dispatch(setShortlistError('limit_premium'));
      toastRender('error', 'Shortlist is full.');
      return { ok: false, status: 205 };
    }
    if (response.status === 202) {
      toastRender('error', 'That player is in another universe.');
      return { ok: false, status: 202 };
    }
    if (response.status === 203) {
      toastRender('error', 'That player has retired.');
      return { ok: false, status: 203 };
    }
    if (response.status === 201) {
      toastRender('error', 'Player not found.');
      return { ok: false, status: 201 };
    }
    toastRender('error', 'Could not update shortlist.');
    return { ok: false, status: response.status };
  };

export const shortlistRemovePlayer = (playerId) => async (dispatch, getState) => {
  let response;
  try {
    response = await removeFromShortlist(playerId);
  } catch {
    toastRender('error', 'Could not update shortlist.');
    return { ok: false };
  }
  if (response.status === 200) {
    const items = (getState().shortlist?.items || []).filter(
      (item) => item.player !== String(playerId)
    );
    dispatch(setShortlist(items));
    return { ok: true };
  }
  toastRender('error', 'Could not update shortlist.');
  return { ok: false, status: response.status };
};

export const toggleShortlistPlayer = (playerId) => async (dispatch, getState) => {
  const listed = (getState().shortlist?.items || []).some(
    (item) => item.player === String(playerId)
  );
  if (listed) {
    return dispatch(shortlistRemovePlayer(playerId));
  }
  return dispatch(shortlistAddPlayer(playerId));
};
